import React, { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Preloader from './components/preloader';

const Cursor = lazy(() => import('./components/cursor'));

const Home = lazy(() => import('./pages/home'));
const Programs = lazy(() => import('./pages/programs'));
const Startups = lazy(() => import('./pages/startups'));
const Booking = lazy(() => import('./pages/booking'));
const Contact = lazy(() => import('./pages/contact'));
const Error = lazy(() => import('./pages/error'));

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

const Routing = () => {
  const [showCursor, setShowCursor] = useState(false);

  useEffect(() => {
    const pointerMedia = window.matchMedia('(pointer: fine)');
    const motionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => setShowCursor(pointerMedia.matches && !motionMedia.matches);
    sync();
    pointerMedia.addEventListener('change', sync);
    motionMedia.addEventListener('change', sync);
    return () => {
      pointerMedia.removeEventListener('change', sync);
      motionMedia.removeEventListener('change', sync);
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      {showCursor ? (
        <Suspense fallback={null}>
          <Cursor />
        </Suspense>
      ) : null}
      <a className="skip_link" href="#main-content">Skip to main content</a>
      <Suspense fallback={<Preloader variant="route" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/startups" element={<Startups />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contactus" element={<Contact />} />
          <Route path="/*" element={<Error />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routing;
